import React, { useState } from 'react';
import Header from './Header';

function Page1() {
  const params = new URLSearchParams(window.location.search);
  const fiscalYear = params.get('fiscal_year');
  const town = params.get('town');
  const townCode = params.get('town_code');
  const formType = params.get('form_type');
  const isForm2 = formType === 'form_2';

  const [fiscalYearEditable, setFiscalYearEditable] = useState(fiscalYear || new Date().getFullYear().toString());
  const [ownerName, setOwnerName] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [entityType, setEntityType] = useState('');
  const [fidNumber, setFidNumber] = useState('');
  const [natureOfBusiness, setNatureOfBusiness] = useState('');
  const [stateOfFormation, setStateOfFormation] = useState('');
  const [dateOfFormation, setDateOfFormation] = useState('');
  const [businessAddress, setBusinessAddress] = useState('');
  const [legalResidence, setLegalResidence] = useState('');
  const [propertyOwnership, setPropertyOwnership] = useState('');
  const [mailingAddress, setMailingAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState(localStorage.getItem('userEmail') || '');
  const [propertyLocation, setPropertyLocation] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const nullIfEmpty = (val) => val === '' ? null : val;
const data = {
  fiscalYear: fiscalYearEditable, town, townCode, formType,
  ownerName,
  businessName: nullIfEmpty(businessName),
  entityType: nullIfEmpty(entityType),
  fidNumber: nullIfEmpty(fidNumber),
  natureOfBusiness: nullIfEmpty(natureOfBusiness),
  stateOfFormation: nullIfEmpty(stateOfFormation),
  dateOfFormation: nullIfEmpty(dateOfFormation),
  businessAddress: nullIfEmpty(businessAddress),
  legalResidence: nullIfEmpty(legalResidence),
  propertyOwnership: nullIfEmpty(propertyOwnership),
  mailingAddress: nullIfEmpty(mailingAddress),
  phone, email, propertyLocation,
};
    sessionStorage.setItem('page1Data', JSON.stringify(data));
    window.location.href = '/page2';
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <Header step={1} />
        <p style={styles.meta}>
          {isForm2 ? 'Form 2 — Business' : 'Form 2HF — Second Home'} &nbsp;|&nbsp; {town}
        </p>
        <h2 style={styles.subtitle}>Page 1 — Filer Information</h2>
        <p style={styles.required}>* Required field</p>

        <form onSubmit={handleSubmit}>

          <div style={styles.field}>
  <label style={styles.label}>Fiscal Year *</label>
  <input
    style={styles.input}
    type="number"
    value={fiscalYearEditable}
    onChange={(e) => setFiscalYearEditable(e.target.value)}
    min="2020"
    max="2030"
    required
  />
</div>
          <div style={styles.field}>
            <label style={styles.label}>Owner / Taxpayer Name *</label>
            <input style={styles.input} type="text" value={ownerName}
              onChange={(e) => setOwnerName(e.target.value)} required />
          </div>

          {isForm2 && (
            <div style={styles.field}>
              <label style={styles.label}>Business Name</label>
              <input style={styles.input} type="text" value={businessName}
                onChange={(e) => setBusinessName(e.target.value)} />
            </div>
          )}

          {isForm2 && (
            <div style={styles.field}>
              <label style={styles.label}>Entity Type *</label>
              <select style={styles.input} value={entityType}
                onChange={(e) => setEntityType(e.target.value)} required>
                <option value="">Select one...</option>
                <option value="Individual">Individual</option>
                <option value="LLC">LLC</option>
                <option value="Corporation">Corporation</option>
                <option value="Partnership">Partnership</option>
                <option value="Trust">Trust</option>
                <option value="Other">Other</option>
              </select>
            </div>
          )}

          {isForm2 && (
            <div style={styles.field}>
              <label style={styles.label}>Federal ID Number</label>
              <input style={styles.input} type="text" value={fidNumber}
                onChange={(e) => setFidNumber(e.target.value)} />
            </div>
          )}

          {isForm2 && (
            <div style={styles.field}>
              <label style={styles.label}>Nature of Business *</label>
              <input style={styles.input} type="text" value={natureOfBusiness}
                onChange={(e) => setNatureOfBusiness(e.target.value)} required />
            </div>
          )}

          {isForm2 && (
            <div style={styles.field}>
              <label style={styles.label}>State of Formation</label>
              <input style={styles.input} type="text" value={stateOfFormation}
                onChange={(e) => setStateOfFormation(e.target.value)} />
            </div>
          )}

          {isForm2 && (
            <div style={styles.field}>
              <label style={styles.label}>Date of Formation</label>
              <input style={styles.input} type="date" value={dateOfFormation}
                onChange={(e) => setDateOfFormation(e.target.value)} />
            </div>
          )}

          {isForm2 && (
            <div style={styles.field}>
              <label style={styles.label}>Business Address *</label>
              <input style={styles.input} type="text" value={businessAddress}
                onChange={(e) => setBusinessAddress(e.target.value)} required />
            </div>
          )}

          {!isForm2 && (
            <div style={styles.field}>
              <label style={styles.label}>Legal Residence on Jan 1 *</label>
              <input style={styles.input} type="text" value={legalResidence}
                onChange={(e) => setLegalResidence(e.target.value)} required />
            </div>
          )}

          {!isForm2 && (
            <div style={styles.field}>
              <label style={styles.label}>Property Ownership *</label>
              <select style={styles.input} value={propertyOwnership}
                onChange={(e) => setPropertyOwnership(e.target.value)} required>
                <option value="">Select one...</option>
                <option value="Own">Own</option>
                <option value="Rent">Rent</option>
              </select>
            </div>
          )}

          <div style={styles.field}>
            <label style={styles.label}>Mailing Address</label>
            <input style={styles.input} type="text" value={mailingAddress}
              onChange={(e) => setMailingAddress(e.target.value)} />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Property Location in {town} *</label>
            <input style={styles.input} type="text" value={propertyLocation}
              onChange={(e) => setPropertyLocation(e.target.value)} required />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Phone *</label>
            <input style={styles.input} type="tel" value={phone}
              onChange={(e) => setPhone(e.target.value)} required />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Email *</label>
            <input style={styles.input} type="email" value={email}
              onChange={(e) => setEmail(e.target.value)} required />
          </div>

          <button style={styles.button} type="submit">Continue to Page 2</button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '520px',
  },
  meta: {
    textAlign: 'center',
    fontSize: '13px',
    color: '#666',
    marginBottom: '8px',
  },
  subtitle: {
    color: '#444',
    fontSize: '18px',
    marginBottom: '24px',
    textAlign: 'center',
  },
  field: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    marginBottom: '6px',
    color: '#333',
    fontSize: '14px',
    fontWeight: '600',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    marginTop: '8px',
  },
  required: {
    fontSize: '12px',
    color: '#666',
    marginBottom: '20px',
    textAlign: 'right',
  },
};

export default Page1;